/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BrandAccessDto interface.
 */
export function instanceOfBrandAccessDto(value) {
    if (!('brandId' in value) || value['brandId'] === undefined)
        return false;
    if (!('allLocations' in value) || value['allLocations'] === undefined)
        return false;
    return true;
}
export function BrandAccessDtoFromJSON(json) {
    return BrandAccessDtoFromJSONTyped(json, false);
}
export function BrandAccessDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brandId': json['brandId'],
        'allLocations': json['allLocations'],
        'locationIds': json['locationIds'] == null ? undefined : json['locationIds'],
    };
}
export function BrandAccessDtoToJSON(json) {
    return BrandAccessDtoToJSONTyped(json, false);
}
export function BrandAccessDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brandId': value['brandId'],
        'allLocations': value['allLocations'],
        'locationIds': value['locationIds'],
    };
}
//# sourceMappingURL=BrandAccessDto.js.map